import React from "react";
import { components } from "react-select";

const Icon = () => {
  return (
    <svg
      width="11"
      height="20"
      viewBox="0 0 11 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2959 1.25L9.99986 9.95396L1.2959 18.6579"
        stroke="#979495"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
